// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — preview.styled.classic.js, новая — preview.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './preview.styled.classic';
import * as cp from './preview.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
